import React from 'react';
import { useHistory } from 'react-router-dom';
import './LoginWidget.scss';

const LoginWidget = () => {
  const history = useHistory();
  return (
    <section className="widget">
      <div className="support-widget">
        <h3 className="title">Want to login?</h3>
        <p className="intro">
          Can&lsquo;t edit? Click
          {' '}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a className="login-quick-link" onClick={() => history.push('/login')}>
            here
          </a>
          {' '}
          to go to login page.
        </p>
      </div>
    </section>
  );
};

export default LoginWidget;
